// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.SubscriptionPlanSelector__root--MKqs {
    max-width: 600px;
    width: 100%;
    margin: 0 auto;
}

.SubscriptionPlanSelector__plans--rGTo {
    display: flex;
    flex-direction: column;
    gap: 8px;
    margin-bottom: 24px;
}

.SubscriptionPlanSelector__button--LZVT {
    width: 100%;
    max-width: 320px;
    margin: 0 auto;
    display: flex;
    padding: 14px 28px;
    margin-bottom: 24px;
    border-radius: 38px;
    text-transform: uppercase;
    font-size: 16px;
    line-height: 1.5;
    letter-spacing: 0.05em;
    font-weight: 700;
    box-shadow: 0 0 0 0 rgba(56, 87, 255, 0.33);
    animation: SubscriptionPlanSelector__pulse--kNcF 1.25s cubic-bezier(.66,0,0,1) infinite;
}

.SubscriptionPlanSelector__button--LZVT:hover {
        animation: none;
    }

.SubscriptionPlanSelector__safeBlock--Sgy0 {
    width: -moz-max-content;
    width: max-content;
    margin: 0 auto;
    border-radius: 3px;
    background-color: rgba(3, 198, 151, 0.1);
    display: flex;
    padding: 4px 8px;
    justify-content: center;
    align-items: center;
    gap: 4px;
    color: #03C697;
    font-size: 10px;
    font-weight: 500;
    line-height: 12px;
    letter-spacing: 0.1px;
    margin-bottom: 24px;
    text-transform: uppercase;
}

.SubscriptionPlanSelector__safeBlock--Sgy0 > svg {
        width: 16px;
        height: 16px;
    }

.SubscriptionPlanSelector__agreementTermsText--eq2V {
    color: var(--gray-color);
    text-align: center;
    font-size: 14px;
    font-weight: 400;
    line-height: 18px;
    margin-bottom: 24px;
    padding: 0 8px;
}

.SubscriptionPlanSelector__agreementTermsText--eq2V > a {
        text-decoration: underline;
        color: var(--gray-color);
    }

@keyframes SubscriptionPlanSelector__pulse--kNcF {   
    100% {
        box-shadow: 0 0 0 20px #0000;
    }
}
`, "",{"version":3,"sources":["webpack://./src/ui/components/SubscriptionPlanSelector/SubscriptionPlanSelector.css"],"names":[],"mappings":"AAAA;IACI,gBAAgB;IAChB,WAAW;IACX,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;IACR,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,gBAAgB;IAChB,cAAc;IACd,aAAa;IACb,kBAAkB;IAClB,mBAAmB;IACnB,mBAAmB;IACnB,yBAAyB;IACzB,eAAe;IACf,gBAAgB;IAChB,sBAAsB;IACtB,gBAAgB;IAChB,2CAA2C;IAC3C,uFAAuD;AAK3D;;AAHI;QACI,eAAe;IACnB;;AAGJ;IACI,uBAAkB;IAAlB,kBAAkB;IAClB,cAAc;IACd,kBAAkB;IAClB,wCAAwC;IACxC,aAAa;IACb,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;IACnB,QAAQ;IACR,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,qBAAqB;IACrB,mBAAmB;IACnB,yBAAyB;AAM7B;;AAJI;QACI,WAAW;QACX,YAAY;IAChB;;AAGJ;IACI,wBAAwB;IACxB,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,mBAAmB;IACnB,cAAc;AAMlB;;AAJI;QACI,0BAA0B;QAC1B,wBAAwB;IAC5B;;AAGJ;IACI;QACI,4BAA4B;IAChC;AACJ","sourcesContent":[".root {\n    max-width: 600px;\n    width: 100%;\n    margin: 0 auto;\n}\n\n.plans {\n    display: flex;\n    flex-direction: column;\n    gap: 8px;\n    margin-bottom: 24px;\n}\n\n.button {\n    width: 100%;\n    max-width: 320px;\n    margin: 0 auto;\n    display: flex;\n    padding: 14px 28px;\n    margin-bottom: 24px;\n    border-radius: 38px;\n    text-transform: uppercase;\n    font-size: 16px;\n    line-height: 1.5;\n    letter-spacing: 0.05em;\n    font-weight: 700;\n    box-shadow: 0 0 0 0 rgba(56, 87, 255, 0.33);\n    animation: pulse 1.25s cubic-bezier(.66,0,0,1) infinite;\n\n    &:hover {\n        animation: none;\n    }\n}\n\n.safeBlock {\n    width: max-content;\n    margin: 0 auto;\n    border-radius: 3px;\n    background-color: rgba(3, 198, 151, 0.1);\n    display: flex;\n    padding: 4px 8px;\n    justify-content: center;\n    align-items: center;\n    gap: 4px;\n    color: #03C697;\n    font-size: 10px;\n    font-weight: 500;\n    line-height: 12px;\n    letter-spacing: 0.1px;\n    margin-bottom: 24px;\n    text-transform: uppercase;\n\n    > svg {\n        width: 16px;\n        height: 16px;\n    }\n}\n\n.agreementTermsText {\n    color: var(--gray-color);\n    text-align: center;\n    font-size: 14px;\n    font-weight: 400;\n    line-height: 18px;\n    margin-bottom: 24px;\n    padding: 0 8px;\n\n    > a {\n        text-decoration: underline;\n        color: var(--gray-color);\n    }\n}\n\n@keyframes pulse {   \n    100% {\n        box-shadow: 0 0 0 20px #0000;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `SubscriptionPlanSelector__root--MKqs`,
	"plans": `SubscriptionPlanSelector__plans--rGTo`,
	"button": `SubscriptionPlanSelector__button--LZVT`,
	"pulse": `SubscriptionPlanSelector__pulse--kNcF`,
	"safeBlock": `SubscriptionPlanSelector__safeBlock--Sgy0`,
	"agreementTermsText": `SubscriptionPlanSelector__agreementTermsText--eq2V`
};
export default ___CSS_LOADER_EXPORT___;
